import AppRecord from './AppRecord.js'

class EntityCost extends AppRecord {
}

export default EntityCost